module.exports = __webpack_public_path__ + "img/linktree-logo-icon.62ffe1db.svg";